export const examType = {
  MANUAL: 1,
  AUTOMATION: 2,
};
